import { client } from 'lib/evi-api-gateway';

import * as platform_resourceTypes from 'types/platform_resource';

const platform_resource = `${process.env.REACT_APP_API_URL_RESOURCE}/api/platform_resource`;
const main = `${process.env.REACT_APP_API_URL_RESOURCE}/api/main`;

export async function search(params: platform_resourceTypes.search_params) {
  const { tag, topic, series, resource_type, grade, ...rest } = params;
  const formParams: any = {
    ...rest,
    school_only: 'N',
    evi_only: 'N'
  };
  // Add tag parameter if provided
  if (tag && Array.isArray(tag) && tag.length > 0) {
    formParams['tag[0]'] = tag[0];
  }
  // Add topic parameter if provided
  if (topic && Array.isArray(topic) && topic.length > 0) {
    topic.forEach((t, i) => {
      formParams[`topic[${i}]`] = t;
    });
  }
  // Add series parameter if provided
  if (series && Array.isArray(series) && series.length > 0) {
    series.forEach((s, i) => {
      formParams[`series[${i}]`] = s;
    });
  }
  if (resource_type && Array.isArray(resource_type) && resource_type.length > 0) {
    resource_type.forEach((t, i) => {
      formParams[`resource_type[${i}]`] = t;
    });
  }
  if (grade && Array.isArray(grade) && grade.length > 0) {
    grade.forEach((g, i) => {
      formParams[`grade[${i}]`] = g;
    });
  }
  return client.post({
    url: `${platform_resource}/search`,
    form: formParams
  });
}

export async function ai_search(params: platform_resourceTypes.search_params) {
  const { tag, topic, series, resource_type, grade, ...rest } = params;
  const formParams: any = {
    ...rest,
    school_only: 'N',
    evi_only: 'N'
  };
  // Add tag parameter if provided
  if (tag && Array.isArray(tag) && tag.length > 0) {
    formParams['tag[0]'] = tag[0];
  }
  // Add topic parameter if provided
  if (topic && Array.isArray(topic) && topic.length > 0) {
    topic.forEach((t, i) => {
      formParams[`topic[${i}]`] = t;
    });
  }
  // Add series parameter if provided
  if (series && Array.isArray(series) && series.length > 0) {
    series.forEach((s, i) => {
      formParams[`series[${i}]`] = s;
    });
  }
  if (resource_type && Array.isArray(resource_type) && resource_type.length > 0) {
    resource_type.forEach((t, i) => {
      formParams[`resource_type[${i}]`] = t;
    });
  }
  if (grade && Array.isArray(grade) && grade.length > 0) {
    grade.forEach((g, i) => {
      formParams[`grade[${i}]`] = g;
    });
  }
  return client.post({
    url: `${platform_resource}/ai_search`,
    form: formParams
  });
}

// 获取资源搜索类型
export async function getResourceSearchType(params: {
  keyword: string;
  type: string;
  sort: string;
  order: string;
}) {
  return client.post({
    url: `${platform_resource}/get_resource_search_type`,
    form: { ...params }
  });
}

// 记录日志
export async function setLog(params: any) {
  return client.post({
    url: `${main}/set_log`,
    form: { ...params }
  });
}
